<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "MediaGroupMediaWrapper"
    }
</script>

<style scoped>

</style>